import React from "react";
import "./style.scss";
import Competition from "../../components/Competition";

const CompetitionPage = () => {
  return (
    <div className="competition_page_container">
      <div className="competition_page_wrapper">
        <Competition />
      </div>
    </div>
  );
};

export default CompetitionPage;
